import { render, staticRenderFns } from "./CaseActions.vue?vue&type=template&id=7796755e&"
import script from "./CaseActions.vue?vue&type=script&lang=ts&"
export * from "./CaseActions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports